import PortalModal from './PortalModalContainer';

export default PortalModal;
